import React, { useRef, useState, useCallback } from 'react'
import './style.css'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";

const HirePageTestimonial = ({ shortHeading, mainHeading, description, testimonials }) => {

    const sliderRef = useRef();

    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const handleSlideChange = (swiper) => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    };

    return (
        <>
            <section className="hire-page-testimonial-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="new-testomonial-text-box">
                                <h2 className="low-top-white-heading">{shortHeading}</h2>
                                <p
                                    className="capital-main-white-heading"
                                    dangerouslySetInnerHTML={{ __html: mainHeading }}
                                />
                                <p className="description-white-text" dangerouslySetInnerHTML={{ __html: description }} ></p>
                            </div>
                        </div>
                    </div>

                    {/* <div className="row new-testimonial-slider-arrows">
                        <div className="col-md-12">
                            <div className="testimonial-navigation text-center">
                                <span
                                    href="#"
                                    onClick={handlePrev}
                                    className={`left-image ${isBeginning ? "disabled" : ""}`}
                                    style={{
                                        cursor: isBeginning ? "not-allowed" : "pointer",
                                    }}
                                >
                                    <i class="fa-solid fa-arrow-left me-2"></i> Prev
                                </span>
                                <span
                                    href="#"
                                    onClick={handleNext}
                                    className={`${isEnd ? "disabled" : ""}`}
                                    style={{ cursor: isEnd ? "not-allowed" : "pointer" }}
                                >
                                    Next <i class="fa-solid fa-arrow-right ms-2"></i>
                                </span>
                            </div>
                        </div>
                    </div> */}

                    <Swiper
                        slidesPerView={"1"}
                        spaceBetween={0}
                        navigation={false}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        modules={[Navigation, Autoplay]}
                        onSlideChange={handleSlideChange}
                        className="mySwiper"
                        ref={sliderRef}
                    >
                        {testimonials?.map((card, index) => {
                            return <SwiperSlide key={index}>
                                <div className="row pt-5 align-items-end">
                                    {/* Left Side - Image Card */}
                                    <div className="col-xl-5 col-lg-4 col-md-4">
                                        <div className="testimonial-card text-center">
                                            <img src={card?.profileImage} alt={card?.name} className="testimonial-client-image" />
                                            <div className="testimonial-info text-start">
                                                <h6 className="mb-1">{card?.name}</h6>
                                                <p className="mb-1">{card?.designation}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Right Side - Testimonial Text */}
                                    <div className="col-xl-7 col-lg-8 col-md-8">
                                        <div className="testimonial-content testimonail-feedback-text-box">
                                            <span class="fancy-quote-start">“</span>
                                            <p className="hire-page-testimonial-text mb-0">{card?.feedback}</p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        })}
                    </Swiper>
                </div>
            </section>
        </>
    )
}

export default HirePageTestimonial